import React, { useState } from 'react'
import { func, string } from 'prop-types'
import { css } from '@emotion/core'
import { trackEvent } from '@fs/zion-analytics'
import { DialogOverlay, useOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import TreeMain from '../../atf/TreeMain'

const treeCss = css`
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
  display: block;
  height: 85vh;
  overflow: auto;
`

export default function AddTreeFlow({ toggleAtf, sourceThatInitiated, aamState, aamDispatch }) {
  const [t] = useTranslation()
  const [isATFOpen, setIsATFOpen] = useState(false)
  const overlay = useOverlay()
  const { isOpen, transitioning } = overlay

  React.useEffect(() => {
    if (!isOpen) {
      toggleAtf()
    }
  }, [isOpen, toggleAtf])

  if (!isATFOpen) {
    overlay.open()
    setIsATFOpen(true)
  }

  React.useEffect(() => {
    if (isOpen && transitioning) {
      trackEvent({
        event_name: `Add Tree Flow opened via ${sourceThatInitiated}`,
      })
    }
    if (!isOpen && transitioning) {
      trackEvent({
        event_name: 'Add Tree Flow closed',
      })
    }
  }, [isOpen, transitioning, sourceThatInitiated])

  return (
    <DialogOverlay
      title={t('atf.dialog-header', 'Your Family Tree')}
      dismiss={t('common-ui:close.action', 'Close')}
      {...overlay}
      size="xxl"
    >
      <div css={treeCss}>
        {aamDispatch ? (
          <TreeMain overlay={overlay} aamState={aamState} aamDispatch={aamDispatch} />
        ) : (
          <TreeMain overlay={overlay} />
        )}
      </div>
    </DialogOverlay>
  )
}

AddTreeFlow.propTypes = {
  toggleAtf: func,
  sourceThatInitiated: string,
}
